/** @file Reads a PNG's IHDR from its first 33 bytes: signature, chunk type and CRC checked, nothing inflated. */
import { crc32 } from './_internal/crc32';
import { pngInvalid } from './_internal/pngInvalid';

/** The IHDR fields as stored; zero sides, depths and size limits are the caller's to refuse. */
export interface PngIhdr {
  width: number;
  height: number;
  bitDepth: number;
  colorType: number;
  compression: number;
  filter: number;
  /** 0 = none, 1 = Adam7. */
  interlace: number;
}

/** PNG signature, then the IHDR chunk's length (13) and type: PNG requires IHDR first. */
const PREFIX = [137, 80, 78, 71, 13, 10, 26, 10, 0, 0, 0, 13, 73, 72, 68, 82];

/** The IHDR of `bytes`; VALIDATION at `path` unless they start with the signature and a CRC-valid 13-byte IHDR. */
export function readPngIhdr(bytes: Uint8Array, path = 'image'): PngIhdr {
  if (bytes.length < 33 || PREFIX.some((b, i) => bytes[i] !== b)) return pngInvalid(path, 'not a readable PNG file');
  const view = new DataView(bytes.buffer, bytes.byteOffset, 33);
  if (view.getUint32(29) !== crc32(bytes, 12, 29)) return pngInvalid(path, 'not a readable PNG file (the IHDR checksum does not match)');
  const byte = (at: number): number => bytes[at] ?? 0;
  return { width: view.getUint32(16), height: view.getUint32(20), bitDepth: byte(24), colorType: byte(25), compression: byte(26), filter: byte(27), interlace: byte(28) };
}
